import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DateTime, { MONTH_DAY_ORDINAL } from '../../../../DateTime';
import { colors } from '../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../constants/text';
import {
  getRelativeDayName,
  getTimeZoneFormat,
  getRelativeDayString,
} from '../../../../../core/util/date';
import { isBookingWidget } from '../../../../../core/opengraph';
import { getCurrentPath } from '../../../../../core/util/url';
import { getNewBookingLocale } from '../../../../../selectors/newBooking';

const Root = styled.div.withConfig({ componentId: 'sc-y9lzpg-0' })`
  display: flex;
  color: ${colors.myRightFoot};
  font-size: ${fontSize.medium};
  line-height: 18px;
  text-align: center;
  font-family: ${fontFamily.bold};
`;

const Day = styled.div.withConfig({ componentId: 'sc-y9lzpg-1' })`
  margin-right: 4px;
`;

const TimeZoneFormat = styled.span.withConfig({ componentId: 'sc-y9lzpg-2' })`
  margin-left: 5px;
`;

type Props = {
  selectedDate: any;
  timeZone: string;
};

const RelativeDay = ({ selectedDate, timeZone }: Props) => {
  const { t } = useTranslation();
  const locale = useSelector(getNewBookingLocale);
  const relativeDayName = getRelativeDayName(selectedDate, timeZone);
  return (
    <Root>
      <Day>
        {getRelativeDayString(relativeDayName, t)}
        {', '}
      </Day>

      <DateTime
        dateTime={selectedDate}
        format={t('dtFormat.monthAndDate')}
        locale={locale}
        timeZone={timeZone}
      />

      {!isBookingWidget(getCurrentPath()) && (
        <TimeZoneFormat>{`(${getTimeZoneFormat(timeZone, locale)})`}</TimeZoneFormat>
      )}
    </Root>
  );
};

export default RelativeDay;
